module.exports = __webpack_public_path__ + "img/7_144.af3dbc18.png";